import museuScreen  from '../assets/museoRissorgimentoScreen.gif';
import isiScreen from '../assets/isiScreen.gif'
import assistScreen from '../assets/assistScreen.gif';
import aisScreen from '../assets/aisScreen.gif';
import manonScreen from '../assets/manonScreen.gif';
import p3qScreen from '../assets/p3qScreen.gif';
import boraProRole from '../assets/boraProRoleScreen.gif';
import StreeenScreen from '../assets/streeenScreen.gif';

export const worksData = [
    {
        link: 'https://bora-pro-role.vercel.app/',
        name:'Bora pro Rolê - Join us as we explore the wonders of Italy and share tips, stories, and curiosities that make this place truly unique!',
        category: 'Work',
        date: 'jan.2025',
        img: boraProRole,
        colorBg: 'hsla(56, 94%, 94%, 1)'
    },
    {
        link: 'https://streeen.org/',
        name:'Streeen - Discover a unique multi-streaming system, with hundreds of carefully selected films including feature films, shorts and documentaries',
        category: 'Work',
        date: 'dec.2024',
        img: StreeenScreen,
         colorBg: 'hsla(56, 94%, 94%, 1)'
    },
    {
        link: 'https://www.p3q.it/',
        name:'Tre Querce - an adventure in the Collina di Superga Natural Park',
        category: 'Work',
        date: 'may.2024',
        img: p3qScreen,
        colorBg: 'var(--color-primary)'
    },
    {
        link: 'https://manon.teatroregio.torino.it/',
        name:'Teatro Regio - Landing Page to present Manon Manon Manon in Italy',
        category: 'Work',
        date: 'apr.2024',
        img: manonScreen,
        colorBg: 'hsla(56, 94%, 94%, 1)'
    },
/*     {
        link: 'https://isi.it/en/home',
        name:'ISI Foundation - Pioneering Data-Driven Science for Social Impact',
        category: 'Work',
        date: 'mar.2024',
        img: isiScreen,
        colorBg: 'var(--color-secondary)',
    }, */
/*     {
        link: 'https://www.museorisorgimentotorino.it/',
        name:'Museo Risorgimento - Gateway to History with a new Landing Page',
        category: 'Work',
        date: 'jan.2024',
        img: museuScreen,
        colorBg: 'hsla(0, 0, 0, 1)'
    }, */
/*     {
        link: 'https://assist-si.com/',
        name:'Assist - Streamlining Credit Collection with Appointment Booking',
        category: 'Work',
        date: 'nov.2023',
        img: assistScreen,
        colorBg: 'var(--color-primary)'
    }, */
]